// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3yhSa","title":"InfoRow_title__VIbLg"};